define.alias("shared/components/shared/post/secondary/activity/comment", "media/components/shared/post/secondary/activity/comment");